export const BRAND_DEFAULTS = {
  slug: "default",
  primary_color: "#5A61E5",
  primary_color_rgb: "90 97 229",
  accent_color: "#F2BF53",
  accent_color_rgb: "242 191 83",
  logo_dark_url:
    "https://jszgeoosgpozjlvohrjy.supabase.co/storage/v1/object/public/assets/logo%20morado.png",
  logo_light_url:
    "https://jszgeoosgpozjlvohrjy.supabase.co/storage/v1/object/public/assets/logo%20blanco.png",
  icon_url:
    "https://jszgeoosgpozjlvohrjy.supabase.co/storage/v1/object/public/assets/icon.png",
  og_image_url:
    "https://jszgeoosgpozjlvohrjy.supabase.co/storage/v1/object/public/assets/logo%20morado.png",
  whatsapp_logo_url:
    "https://jszgeoosgpozjlvohrjy.supabase.co/storage/v1/object/public/assets/icon.png",
};

export const BRAND_CACHE_KEY = "elancla:brand_settings_cache";
export const BRAND_CACHE_TTL = 1000 * 60 * 60; // 1 hour
